module.exports = __webpack_public_path__ + "img/banner-20.4916d89a.jpg";